var _style, _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSocialmediaInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.9966,
    y1: 363.8875,
    x2: 362.0971,
    y2: 225.7868,
    gradientTransform: "matrix(0.512 0 0 0.512 -100.04 -100.9566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFD521"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0551,
    style: {
      stopColor: "#FFD020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1241,
    style: {
      stopColor: "#FEC01E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2004,
    style: {
      stopColor: "#FCA71B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2821,
    style: {
      stopColor: "#FA8316"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    style: {
      stopColor: "#F85510"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    style: {
      stopColor: "#F51E09"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F30005"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5035,
    style: {
      stopColor: "#F20007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5966,
    style: {
      stopColor: "#E1003B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6879,
    style: {
      stopColor: "#D30067"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7757,
    style: {
      stopColor: "#C70088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8589,
    style: {
      stopColor: "#BF00A0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    style: {
      stopColor: "#BB00AF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B900B4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,100L50,100C22.4,100,0,77.6,0,50S22.4,0,50,0s50,22.4,50,50S77.6,100,50,100z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,15.9c-9.3,0-10.4,0-14.1,0.2c-3.6,0.2-6.1,0.7-8.3,1.6c-2.2,0.9-4.2,2-6,3.9c-1.9,1.9-3.1,3.8-3.9,6.1 c-0.8,2.2-1.4,4.7-1.6,8.3c-0.2,3.6-0.2,4.8-0.2,14.1s0,10.4,0.2,14.1c0.2,3.6,0.7,6.1,1.6,8.3c0.9,2.2,2,4.1,3.9,6 c1.9,1.9,3.8,3.1,6.1,3.9c2.2,0.8,4.7,1.4,8.3,1.6c3.6,0.2,4.8,0.2,14.1,0.2s10.4,0,14.1-0.2c3.6-0.2,6.1-0.7,8.3-1.6 c2.2-0.9,4.1-2,6-3.9c1.9-1.9,3.1-3.8,3.9-6.1c0.8-2.2,1.4-4.7,1.6-8.3c0.2-3.6,0.2-4.8,0.2-14.1s0-10.4-0.2-14.1 c-0.2-3.6-0.7-6.1-1.6-8.3c-0.9-2.2-2-4.1-3.9-6c-1.9-1.9-3.8-3.1-6.1-3.9c-2.2-0.8-4.7-1.4-8.3-1.6C60.4,15.9,59.3,15.9,50,15.9z  M50,22c9.1,0,10.2,0,13.8,0.2c3.3,0.1,5.1,0.7,6.3,1.2c1.6,0.6,2.7,1.4,3.9,2.5c1.2,1.2,1.9,2.3,2.5,3.9c0.5,1.2,1,3,1.2,6.3 C77.9,39.8,78,40.9,78,50s0,10.2-0.2,13.8c-0.1,3.3-0.7,5.1-1.2,6.3c-0.6,1.6-1.4,2.7-2.5,3.9c-1.2,1.2-2.3,1.9-3.9,2.5 c-1.2,0.5-3,1-6.3,1.2C60.2,77.9,59.1,78,50,78s-10.2,0-13.8-0.2c-3.3-0.1-5.1-0.7-6.3-1.2c-1.6-0.6-2.7-1.4-3.9-2.5 c-1.2-1.2-1.9-2.3-2.5-3.9c-0.5-1.2-1-3-1.2-6.3C22.1,60.2,22,59.1,22,50s0-10.2,0.2-13.8c0.1-3.3,0.7-5.1,1.2-6.3 c0.6-1.6,1.4-2.7,2.5-3.9s2.3-1.9,3.9-2.5c1.2-0.5,3-1,6.3-1.2C39.8,22,40.9,22,50,22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,61.4c-6.3,0-11.4-5.1-11.4-11.4S43.7,38.6,50,38.6S61.4,43.7,61.4,50S56.3,61.4,50,61.4z M50,32.5 c-9.7,0-17.5,7.8-17.5,17.5S40.3,67.5,50,67.5S67.5,59.7,67.5,50S59.7,32.5,50,32.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 68.2,
    cy: 31.8,
    r: 4.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialmediaInstagram);
export default __webpack_public_path__ + "static/media/icon-socialmedia-instagram.287b4f6849c76bc801e40e6132bed8b7.svg";
export { ForwardRef as ReactComponent };